import { StatusMapping, STATUS_GROUP_MAPPING } from '../../types/dsn.types';
import { FilterCondition } from '../../types/filter.types';
import { Logger } from 'loglevel';

export class DsnFilterData {
  private conditions: FilterCondition[] = [];
  private readonly statusMapping: StatusMapping = STATUS_GROUP_MAPPING;

  constructor(private readonly logger: Logger) {}

  getFilters() {
    return this.conditions;
  }

  addDateFilter(startDate: Date | null, endDate: Date | null, isEnabled: boolean = true) {
    this.conditions = this.conditions.filter(c => c.type !== 'date');

    if (startDate || endDate) {
      this.conditions.push({
        type: 'date',
        value: { startDate, endDate },
        isEnabled,
      });
    }
    return this;
  }

  addUserFilter(userId: string | string[] | undefined, isEnabled: boolean): this {
    this.conditions = this.conditions.filter(c => c.type !== 'user');

    if (!userId || !isEnabled) {
      return this;
    }

    let condition: FilterCondition;

    if ((Array.isArray(userId) && userId.length > 0) || typeof userId === 'string') {
      // Gérer un tableau d'IDs utilisateurs ou un seul ID utilisateur
      condition = {
        type: 'user',
        value: userId,
        isEnabled,
      };
    } else {
      return this;
    }

    this.conditions.push(condition);
    return this;
  }

  addTestFilter(isTest: boolean, isEnabled: boolean = true) {
    this.conditions = this.conditions.filter(c => c.type !== 'test');

    this.conditions.push({
      type: 'test',
      value: isTest,
      isEnabled,
    });

    return this;
  }

  addStatusFilter(status: string | null, isEnabled: boolean = true) {
    this.conditions = this.conditions.filter(c => c.type !== 'status');

    if (status && this.statusMapping[status]) {
      this.conditions.push({
        type: 'status',
        value: this.statusMapping[status],
        isEnabled,
      });
    }

    return this;
  }

  addNatureFilter(natures: string[], isEnabled: boolean = true) {
    this.conditions = this.conditions.filter(c => c.type !== 'nature');

    if (natures && natures.length > 0) {
      const mappedNatures = natures.map(nature => nature).filter(Boolean);

      if (mappedNatures.length > 0) {
        this.conditions.push({
          type: 'nature',
          value: mappedNatures,
          isEnabled,
        });
      }
    }

    return this;
  }

  addSearchFilter(searchTerm: string, isEnabled: boolean = true) {
    this.conditions = this.conditions.filter(c => c.type !== 'search');

    if (searchTerm && searchTerm.trim() !== '') {
      const cleanTerm = searchTerm.split('|')[0].trim().toLowerCase();

      if (cleanTerm !== '') {
        this.logger.debug('Adding search condition:', {
          type: 'search',
          value: cleanTerm,
          isEnabled,
        });

        this.conditions.push({
          type: 'search',
          value: cleanTerm,
          isEnabled,
        });
      }
    }

    return this;
  }
}

export default DsnFilterData;
